fragment Review on reviewBlock_Entry { 
    author: reviewAuthor
    date
    score
    quote
    property {
        title
        slug
        uri
    }
}